import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import ContactForm from '../components/ContactForm'

export default function Home() {
  const [pageData, setPageData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const slideshowImages = [
    "https://assets.auxodev.dk/assets/28021fd9-fcdc-43f4-860a-5599c796fdc7/678422f899d34df29745b15c-tts-20sag-20-20ribe.jpg",
    "https://assets.auxodev.dk/assets/28021fd9-fcdc-43f4-860a-5599c796fdc7/6784d4ee8815f9c670344925-tts-20sag.jpg",
    "https://assets.auxodev.dk/assets/28021fd9-fcdc-43f4-860a-5599c796fdc7/677bb8497d4f7a21e927c0d8-sk-c3-a6rmbillede-202025-01-06-20120211.png",
    "https://assets.auxodev.dk/assets/28021fd9-fcdc-43f4-860a-5599c796fdc7/6784d516d99ca1560a1e3046-trapez-20-20give.jpg"
  ]

  const [currentSlide, setCurrentSlide] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slideshowImages.length)
    }, 5000)
    return () => clearInterval(timer)
  }, [])

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slideshowImages.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slideshowImages.length) % slideshowImages.length)
  }

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/pages')
      .then(res => {
        if (!res.ok) throw new Error('Kunne ikke hente data')
        return res.json()
      })
      .then(data => {
        const home = data.find(p => p.page_slug === 'index')
        setPageData(home)
        setLoading(false)
      })
      .catch(err => {
        console.error(err)
        setError(err.message)
        setLoading(false)
      })
  }, [])

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <i className="fa-solid fa-spinner animate-spin text-4xl text-brand-orange"></i>
          <p className="text-slate-500 font-medium">Indlæser indhold...</p>
        </div>
      </div>
    )
  }

  // Fallback data matching the scrape exactly if CMS fetch fails
  const fallbackData = {
    title: "Trapezdk",
    meta_title: "Trapezdk",
    meta_description: "Trapezdk i Brabrand tilbyder professionelle løsninger med fokus på kvalitet, overblik og personlig kontakt. Kontakt Trapezdk for more information.",
    content: `<h1>Vores levering og montering af trapezplader er i højeste kvalitet</h1><p>Uanset jeres projekts størrelse kan vi stå for leveringen og montering af vores trapezplader i højeste kvalitet. Vi er med i hele processen og står for rådgivning, og finder den bedste montageplan til projektet. I kan se nogle af vores resultater ved at trykke på knappen herunder.</p><h2>Højprofiler</h2><p>Trapez er a moderne højprofil, der sikrer gode og totaløkonomiske fordele samt hurtige montagemuligheder. De store trapezplader har gode selvbærende egenskaber og kan klare store spænd, hvilket medvirker til et stærkt slutresultat og hurtige montagemuligheder med lang holdbarhed. De stærke højprofiler er som oftest selvbærende op til 10 meter og den lave produktvægt skaber ideelle muligheder for at få lagt taget i et raskt tempo.</p><p>Disse højprofiler udformes med forskellige egenskaber, der gør dem anvendelige i mange forskellige typer af projekter og bygningstyper. Selvsamme årsag gør en højprofil anvendelig lige fra industriområder til kontorbygninger, hvor bl.a. den gode akustiske virkning gør ekstra god nytte.</p><p>Med en højprofil leveret fra os står den stærkt, flot og med mulighed for at kombinere øvrige produkter som bl.a. tagrender, skruer, hætter, inddækninger osv. Du får ligeledes glæde af solide galvaniserede elementer, der er lette at vedligeholde og rengøre samt de kan leveres perforerede med flot mønstertype for f.eks. at skabe bedre akustik.</p>`,
    images: ["https://assets.auxodev.dk/assets/28021fd9-fcdc-43f4-860a-5599c796fdc7/678422f899d34df29745b15c-tts-20sag-20-20ribe.jpg"]
  }

  const data = pageData || fallbackData

  return (
    <div className="w-full">
      <Helmet>
        <title>{data.meta_title || "Trapezdk"}</title>
        <meta name="description" content={data.meta_description || "Trapezdk i Brabrand tilbyder professionelle løsninger med fokus på kvalitet, overblik og personlig kontakt."} />
        <meta property="og:title" content={data.meta_title || "Trapezdk"} />
        <meta property="og:description" content={data.meta_description || "Trapezdk i Brabrand tilbyder professionelle løsninger med fokus på kvalitet, overblik og personlig kontakt."} />
        <meta property="og:image" content={data.images?.[0] || ""} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/* Hero Section */}
      <section className="relative bg-slate-950 text-white py-20 lg:py-28 overflow-hidden">
        {/* Background Image with Dark Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ 
            backgroundImage: `url('https://assets.auxodev.dk/cdn-cgi/image/width=1920,quality=80,format=auto/assets/28021fd9-fcdc-43f4-860a-5599c796fdc7/677bb8497d4f7a21e927c0d8-sk-c3-a6rmbillede-202025-01-06-20120211.png')` 
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950/90 via-slate-900/85 to-slate-950/90"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-brand-orange/5 rounded-full blur-3xl"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Hero Text */}
          <div className="lg:col-span-7 flex flex-col gap-6 text-left">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight text-white">
              Vores levering og montering af trapezplader er i højeste kvalitet
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl">
              Uanset jeres projekts størrelse kan vi stå for leveringen og montering af vores trapezplader i højeste kvalitet. Vi er med i hele processen og står for rådgivning, og finder den bedste montageplan til projektet. I kan se nogle af vores resultater ved at trykke på knappen herunder.
            </p>
            <div className="flex flex-wrap gap-4 pt-2">
              <Link 
                to="/referencer" 
                className="px-6 py-3.5 bg-brand-orange hover:bg-brand-orange-hover text-white font-semibold rounded-xl transition-all shadow-md hover:shadow-lg flex items-center gap-2 cursor-pointer"
              >
                <span>Vores Referencer</span>
                <i className="fa-solid fa-arrow-right text-sm"></i>
              </Link>
              <Link 
                to="/tilbud" 
                className="px-6 py-3.5 bg-white/10 hover:bg-white/15 text-white border border-white/20 font-semibold rounded-xl transition-all flex items-center gap-2 cursor-pointer"
              >
                <span>Indhent tilbud</span>
              </Link>
            </div>
          </div>

          {/* Hero Image Slideshow */}
          <div className="lg:col-span-5 relative">
            {/* Dark box-shadow glow (dark, not orange) */}
            <div className="absolute -inset-2 bg-slate-950/40 rounded-none blur-md"></div>
            
            <div className="relative bg-slate-950 rounded-none overflow-hidden shadow-[0_25px_60px_-15px_rgba(0,0,0,0.85)] border border-slate-800 h-[350px] sm:h-[450px] md:h-[500px] lg:h-[550px] w-full group">
              {slideshowImages.map((imgUrl, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                    index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
                  }`}
                >
                  <img 
                    src={`https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/${imgUrl.replace('https://assets.auxodev.dk/', '')}`} 
                    alt={`Trapezplader montering ${index + 1}`} 
                    className="w-full h-full object-cover rounded-none"
                  />
                </div>
              ))}

              {/* Navigation Arrows */}
              <button 
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-slate-950/60 hover:bg-slate-950/80 text-white w-10 h-10 flex items-center justify-center transition-all opacity-0 group-hover:opacity-100 cursor-pointer border border-white/10"
                aria-label="Forrige billede"
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button 
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-slate-950/60 hover:bg-slate-950/80 text-white w-10 h-10 flex items-center justify-center transition-all opacity-0 group-hover:opacity-100 cursor-pointer border border-white/10"
                aria-label="Næste billede"
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>

              {/* Slide Indicators (Dots) */}
              <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
                {slideshowImages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2.5 h-2.5 transition-all cursor-pointer ${
                      index === currentSlide ? 'bg-brand-orange w-6' : 'bg-white/50 hover:bg-white/80'
                    }`}
                    aria-label={`Gå til billede ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Stats / Trust Indicators */}
      <section className="bg-white py-8 border-b border-slate-100 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center divide-y sm:divide-y-0 sm:divide-x divide-slate-100">
          <div className="py-4 sm:py-0 flex flex-col items-center gap-1">
            <i className="fa-solid fa-shield-halved text-2xl text-brand-orange mb-1"></i>
            <span className="font-bold text-slate-900">Sikkerhed i top</span>
            <span className="text-xs text-slate-500">Uddannede medarbejdere</span>
          </div>
          <div className="py-4 sm:py-0 flex flex-col items-center gap-1">
            <i className="fa-solid fa-award text-2xl text-brand-orange mb-1"></i>
            <span className="font-bold text-slate-900">Kvalitetssikring</span>
            <span className="text-xs text-slate-500">Løbende KS-rapporter</span>
          </div>
          <div className="py-4 sm:py-0 flex flex-col items-center gap-1">
            <i className="fa-solid fa-handshake text-2xl text-brand-orange mb-1"></i>
            <span className="font-bold text-slate-900">Stærk sparring</span>
            <span className="text-xs text-slate-500">Rådgivning gennem hele processen</span>
          </div>
        </div>
      </section>

      {/* Højprofiler Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <span className="text-brand-orange font-bold text-sm tracking-wider uppercase">Vores Ekspertise</span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-brand-blue mt-2 mb-6">Højprofiler</h2>
            <div className="h-1 w-20 bg-brand-orange mx-auto rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Column: Text Paragraphs */}
            <div className="lg:col-span-7 space-y-6 text-left text-slate-600 leading-relaxed text-base">
              <p className="font-medium text-slate-900 text-lg">
                Trapez er en moderne højprofil, der sikrer gode og totaløkonomiske fordele samt hurtige montagemuligheder. De store trapezplader har gode selvbærende egenskaber og kan klare store spænd, hvilket medvirker til et stærkt slutresultat og hurtige montagemuligheder med lang holdbarhed. De stærke højprofiler er som oftest selvbærende op til 10 meter og den lave produktvægt skaber ideelle muligheder for at få lagt taget i et raskt tempo.
              </p>
              <p>
                Disse højprofiler udformes med forskellige egenskaber, der gør dem anvendelige i mange forskellige typer af projekter og bygningstyper. Selvsamme årsag gør en højprofil anvendelig lige fra industriområder til kontorbygninger, hvor bl.a. den gode akustiske virkning gør ekstra god nytte.
              </p>
              <p>
                Med en højprofil leveret fra os står den stærkt, flot og med mulighed for at kombinere øvrige produkter som bl.a. tagrender, skruer, hætter, inddækninger osv. Du får ligeledes glæde af solide galvaniserede elementer, der er lette at vedligeholde og rengøre samt de kan leveres perforerede med flot mønstertype for f.eks. at skabe bedre akustik.
              </p>
            </div>

            {/* Right Column: Key Features Cards */}
            <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6">
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex gap-4 items-start">
                <div className="w-12 h-12 rounded-xl bg-brand-orange/10 flex items-center justify-center text-brand-orange shrink-0">
                  <i className="fa-solid fa-arrows-left-right text-lg"></i>
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-1">Op til 10m spænd</h3>
                  <p className="text-sm text-slate-500">Selvbærende egenskaber, der muliggør store spænd uden understøtning.</p>
                </div>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex gap-4 items-start">
                <div className="w-12 h-12 rounded-xl bg-brand-orange/10 flex items-center justify-center text-brand-orange shrink-0">
                  <i className="fa-solid fa-weight-hanging text-lg"></i>
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-1">Lav produktvægt</h3>
                  <p className="text-sm text-slate-500">Muliggør hurtig og effektiv montage i et raskt tempo.</p>
                </div>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex gap-4 items-start sm:col-span-2 lg:col-span-1">
                <div className="w-12 h-12 rounded-xl bg-brand-orange/10 flex items-center justify-center text-brand-orange shrink-0">
                  <i className="fa-solid fa-volume-xmark text-lg"></i>
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-1">God akustik</h3>
                  <p className="text-sm text-slate-500">Kan leveres perforerede for at skabe en optimal akustisk virkning.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="bg-brand-blue text-white py-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5 bg-[radial-gradient(ellipse_at_center,rgba(249,115,22,0.3),transparent_70%)]"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10 flex flex-col gap-6 items-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
            Har du et kommende projekt?
          </h2>
          <p className="text-slate-300 max-w-2xl text-base sm:text-lg leading-relaxed">
            Vi står klar med professionel rådgivning, levering og montering. Kontakt os i dag for en uforpligtende snak om jeres behov.
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 pt-4">
            <a 
              href="tel:+4522141149" 
              className="px-6 py-3.5 bg-brand-orange hover:bg-brand-orange-hover text-white font-bold rounded-xl transition-all shadow-md flex items-center gap-2.5 whitespace-nowrap cursor-pointer"
            >
              <i className="fa-solid fa-phone"></i>
              <span>Ring på +45 22 14 11 49</span>
            </a>
            <a 
              href="mailto:dn@trapezdk.dk?subject=Henvendelse%20via%20hjemmesiden" 
              className="px-6 py-3.5 bg-slate-800 hover:bg-slate-750 text-white border border-slate-700 font-bold rounded-xl transition-all flex items-center gap-2.5 whitespace-nowrap cursor-pointer"
            >
              <i className="fa-solid fa-envelope"></i>
              <span>Skriv til dn@trapezdk.dk</span>
            </a>
          </div>
        </div>
      </section>

      {/* Contact & Map Section */}
      <section id="kontakt-sektion" className="py-20 bg-white scroll-mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Contact Info & Map */}
            <div className="lg:col-span-5 space-y-8 text-left">
              <div>
                <span className="text-brand-orange font-bold text-sm tracking-wider uppercase">Kontakt os</span>
                <h2 className="text-3xl font-extrabold text-brand-blue mt-2 mb-4">Trapezdk</h2>
                <p className="text-slate-500 text-sm leading-relaxed">
                  Vi holder til i Brabrand og dækker hele landet med professionelle løsninger.
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-brand-orange shrink-0">
                    <i className="fa-solid fa-location-dot"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm">Adresse</h4>
                    <p className="text-slate-600 text-sm mt-0.5">Rosbjergvej 54C, 8220 Brabrand</p>
                  </div>
                </div>

                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-brand-orange shrink-0">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm">Telefon</h4>
                    <a href="tel:+4522141149" className="text-slate-600 hover:text-brand-orange text-sm mt-0.5 block whitespace-nowrap">
                      +45 22 14 11 49
                    </a>
                  </div>
                </div>

                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-brand-orange shrink-0">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm">E-mail</h4>
                    <a href="mailto:dn@trapezdk.dk?subject=Henvendelse%20via%20hjemmesiden" className="text-slate-600 hover:text-brand-orange text-sm mt-0.5 block whitespace-nowrap">
                      dn@trapezdk.dk
                    </a>
                  </div>
                </div>

                <div className="flex gap-4 items-start">
                  <div className="w-10 h-10 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-brand-orange shrink-0">
                    <i className="fa-solid fa-id-card"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm">CVR-nummer</h4>
                    <p className="text-slate-600 text-sm mt-0.5">45120562</p>
                  </div>
                </div>
              </div>

              {/* Google Maps Embed */}
              <div className="rounded-none overflow-hidden border border-slate-200 shadow-sm h-64 relative group">
                <iframe 
                  title="Trapezdk Beliggenhed"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2222.4284145025793!2d10.084534777322986!3d56.15835697324424!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464c3f6e0756ce43%3A0x860a5599c796fdc7!2sRosbjergvej%2054C%2C%208220%20Brabrand!5e0!3m2!1sda!2sdk!4v1719394500000!5m2!1sda!2sdk" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen="" 
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="grayscale hover:grayscale-0 transition-all duration-500"
                ></iframe>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
